import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Grid,
  MenuItem,
  CircularProgress,
  Typography,
  Card,
  Accordion,
  AccordionSummary,
  IconButton,
  AccordionDetails,
  CardContent,
  CardHeader,
  Grid2,
  useTheme,
  useMediaQuery,
  Stack,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  addAddress,
  deleteAddres,
  GetAddress,
  GetCompanyAction,
  UpdateAddress,
} from "../../../../redux/actions/companyAction";
import useAlert from "../../../../hooks/useAlert";
import { validateAddresAdd } from "../../../../utils/validation";
import {
  ExpandMore as ExpandMoreIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { green } from "@mui/material/colors";

const AddressSettings = () => {
  useEffect(() => {
    getCompany();
  }, []);
  const [companyId, setcompanyId] = useState("");
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [expanded, setExpanded] = useState(false); // expanded state tanımı
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const { showSuccessUpdateAddress, showErrorAlertUpdateAddress } = useAlert();
  const { showSuccessAddAddress, showErrorAlertAddAddress } = useAlert();
  const { showSuccessAddressDelete, showErrorAlertAddressDelete } = useAlert();
  const deleteAddress = async (id) => {
    const confirmDelete = window.confirm(
      "Bu adresi silmek istediğinizden emin misiniz?"
    );

    if (confirmDelete) {
      try {
        const response = await dispatch(deleteAddres(id, token));

        if (response.status) {
          showSuccessAddressDelete();
          getAddress();
        }
        return response;
      } catch (error) {
        showErrorAlertAddressDelete();
        console.error("Error deleting address:", error);
      }
    }
  };

  const handleInputChangeAddressUpdate = (e, index) => {
    const { name, value } = e.target;
    setuserAddress((prevAddresses) =>
      prevAddresses.map((addr, idx) =>
        idx === index ? { ...addr, [name]: value } : addr
      )
    );
  };
  const getCompany = async () => {
    try {
      const response = await dispatch(GetCompanyAction(authUserId, token));
      setcompanyId(response.data[0].id);
    } catch (error) {
      console.error("Error fetching store:", error);
    }
  };
  const [formValuesAddres, setFormValuesAddres] = useState({
    type: "",
    province: "",
    district: "",
    postalCode: "",
    detail: "",
    userId: "",
    companyId: "",
  });
  const { loading, error } = useSelector((state) => state.auth);
  const [addresses, setuserAddress] = useState([]);
  const [formErrors, setFormErrors] = useState({});

  const dispatch = useDispatch();

  const handleInputChangeAddres = (event) => {
    const { name, value } = event.target;
    setFormValuesAddres((prevValues) => ({ ...prevValues, [name]: value }));
  };
  const addAddres = async (e) => {
    e.preventDefault();
    if (!companyId > 0) {
      alert("Adres bilgisi eklemek için şirket bilgileri eksik olmamalı");
      return;
    }
    formValuesAddres.userId = authUserId;
    formValuesAddres.companyId = companyId;
    const errors = validateAddresAdd(formValuesAddres);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      try {
        await dispatch(addAddress(formValuesAddres, token));
        showSuccessAddAddress();
        getAddress();
      } catch {
        showErrorAlertAddAddress();
      }
    }
  };
  //adres bilgilerini getir
  const getAddress = async () => {
    try {
      const id = companyId;
      const response = await dispatch(GetAddress(id, token));
      setuserAddress(response.data);
      return response;
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  //adres bilgilerini güncelle
  const updateAddress = async (data) => {
    data.appUserId = authUserId;
    const errors = validateAddresAdd(data);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      try {
        await dispatch(UpdateAddress(data, token));
        showSuccessUpdateAddress();
        getAddress();
      } catch (err) {
        showErrorAlertUpdateAddress();
        console.error("Güncelleme hatası:", err);
      }
    }
  };

  useEffect(() => {
    getAddress();
  }, [companyId]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      sx={{
        mt: { xs: 2, sm: 3 },
        overflowX: "hidden",
        px: { xs: 1, sm: 2 },
      }}
    >
      <Box
        component="form"
        sx={{
          mt: { xs: 2, sm: 3 },
          width: "100%",
        }}
        onSubmit={addAddres}
      >
        <Grid container spacing={{ xs: 1.5, sm: 2 }}>
          {/* Address Type Dropdown */}
          <Grid item xs={12}>
            <TextField
              size={isMobile ? "small" : "medium"}
              select
              name="type"
              fullWidth
              label="Adres Tipi"
              value={formValuesAddres.type}
              onChange={handleInputChangeAddres}
              error={!!formErrors.type}
              helperText={formErrors.type}
              sx={{
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
                "& .MuiSelect-select": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
              }}
            >
              <MenuItem value={1}>Sevkiyat</MenuItem>
              <MenuItem value={2}>Fatura</MenuItem>
              <MenuItem value={3}>İletişim</MenuItem>
              <MenuItem value={4}>İade</MenuItem>
            </TextField>
          </Grid>

          {/* Address Detail */}
          <Grid item xs={12}>
            <TextField
              size={isMobile ? "small" : "medium"}
              name="detail"
              fullWidth
              label="Adres Detayı"
              multiline
              maxRows={4}
              value={formValuesAddres.detail}
              onChange={handleInputChangeAddres}
              error={!!formErrors.detail}
              helperText={formErrors.detail}
              sx={{
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
                "& .MuiInputBase-input": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
              }}
            />
          </Grid>

          {/* Province and District in a row */}
          <Grid item xs={12} sm={6}>
            <TextField
              size={isMobile ? "small" : "medium"}
              name="province"
              fullWidth
              label="İl"
              value={formValuesAddres.province}
              onChange={handleInputChangeAddres}
              error={!!formErrors.province}
              helperText={formErrors.province}
              sx={{
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
                "& .MuiInputBase-input": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              size={isMobile ? "small" : "medium"}
              name="district"
              fullWidth
              label="İlçe"
              value={formValuesAddres.district}
              onChange={handleInputChangeAddres}
              error={!!formErrors.district}
              helperText={formErrors.district}
              sx={{
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
                "& .MuiInputBase-input": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              size={isMobile ? "small" : "medium"}
              name="postalCode"
              fullWidth
              label="Posta kodu"
              value={formValuesAddres.postalCode}
              onChange={handleInputChangeAddres}
              error={!!formErrors.postalCode}
              helperText={formErrors.postalCode}
              sx={{
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
                "& .MuiInputBase-input": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                },
              }}
            />
          </Grid>
        </Grid>

        {/* Submit Button */}
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              mt: { xs: 2, sm: 4 },
              mb: { xs: 1, sm: 2 },
              borderRadius: 2,
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.813rem", sm: "0.875rem" },
              padding: { xs: "8px 16px", sm: "10px 20px" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              "&:hover": {
                backgroundColor: "#2C285A",
              },
            }}
            disabled={loading}
          >
            {formValuesAddres.id ? (
              loading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Adresi Güncelle"
              )
            ) : loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Adresi Ekle"
            )}
          </Button>
        </Grid>
        {error && (
          <Typography
            color="error"
            sx={{
              fontSize: { xs: "0.875rem", sm: "1rem" },
              mt: 1,
            }}
          >
            {error.message}
          </Typography>
        )}
      </Box>

      {/* Address Cards */}
      {addresses?.length > 0 && (
        <>
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            sx={{
              p: 0,
              mb: { xs: 1, sm: 2 },
              mt: { xs: 2, sm: 4 },
              fontWeight: "bold",
              color: "primary.main",
              fontSize: { xs: "1.25rem", sm: "1.5rem" },
            }}
          >
            Adresler
          </Typography>
          <Grid
            container
            spacing={{ xs: 2, sm: 3 }}
            sx={{
              maxWidth: "100%",
              margin: "auto",
              mt: { xs: 2, sm: 4 },
              mb: { xs: 1, sm: 2 },
            }}
          >
            {addresses.map((address, index) => (
              <Grid item xs={12} sm={6} md={6} lg={6} key={address.id}>
                <Card
                  sx={{
                    width: "100%",
                    boxShadow: { xs: 2, sm: 5 },
                    borderRadius: 2,
                  }}
                >
                  <AccordionSummary
                    aria-controls={`panel${index}bh-content`}
                    id={`panel${index}bh-header`}
                    sx={{
                      backgroundColor: (theme) => theme.palette.grey[50],
                      "&:hover": {
                        backgroundColor: (theme) => theme.palette.grey[200],
                      },
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      minHeight: { xs: 48, sm: 64 },
                      "& .MuiAccordionSummary-content": {
                        margin: { xs: "8px 0", sm: "12px 0" },
                      },
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: "1rem", sm: "1.25rem" },
                        fontWeight: 500,
                      }}
                    >
                      {address.type === 1
                        ? "Sevkiyat Adresi"
                        : address.type === 2
                        ? "Fatura Adresi"
                        : address.type === 3
                        ? "İletişim Adresi"
                        : "İade Adresi"}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "auto",
                      }}
                    >
                      <IconButton
                        size={isMobile ? "small" : "medium"}
                        onClick={(event) => {
                          event.stopPropagation();
                          deleteAddress(address.id);
                        }}
                        sx={{ p: { xs: 0.5, sm: 1 } }}
                      >
                        <DeleteIcon
                          sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
                        />
                      </IconButton>
                      <IconButton
                        size={isMobile ? "small" : "medium"}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleAccordionChange(`panel${index}`)(event, true);
                        }}
                        sx={{ p: { xs: 0.5, sm: 1 } }}
                      >
                        <ExpandMoreIcon
                          sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
                        />
                      </IconButton>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
                      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
                        {/* Address Type */}
                        <Grid item xs={12}>
                          <TextField
                            size={isMobile ? "small" : "medium"}
                            select
                            name="type"
                            fullWidth
                            label="Adres Tipi"
                            value={address.type}
                            onChange={(e) =>
                              handleInputChangeAddressUpdate(e, index)
                            }
                            error={!!formErrors.type}
                            helperText={formErrors.type}
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                              "& .MuiSelect-select": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                            }}
                          >
                            <MenuItem value={1}>Sevkiyat</MenuItem>
                            <MenuItem value={2}>Fatura</MenuItem>
                            <MenuItem value={3}>İletişim</MenuItem>
                            <MenuItem value={4}>İade</MenuItem>
                          </TextField>
                        </Grid>

                        {/* Address Detail */}
                        <Grid item xs={12}>
                          <TextField
                            size={isMobile ? "small" : "medium"}
                            name="detail"
                            fullWidth
                            multiline
                            rows={4}
                            value={address.detail}
                            onChange={(e) =>
                              handleInputChangeAddressUpdate(e, index)
                            }
                            error={!!formErrors.detail}
                            helperText={formErrors.detail}
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                              "& .MuiInputBase-input": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                            }}
                          />
                        </Grid>

                        {/* Province and District */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            size={isMobile ? "small" : "medium"}
                            name="province"
                            fullWidth
                            label="İl"
                            value={address.province}
                            onChange={(e) =>
                              handleInputChangeAddressUpdate(e, index)
                            }
                            error={!!formErrors.province}
                            helperText={formErrors.province}
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                              "& .MuiInputBase-input": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            size={isMobile ? "small" : "medium"}
                            name="district"
                            fullWidth
                            label="İlçe"
                            value={address.district}
                            onChange={(e) =>
                              handleInputChangeAddressUpdate(e, index)
                            }
                            error={!!formErrors.district}
                            helperText={formErrors.district}
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                              "& .MuiInputBase-input": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                            }}
                          />
                        </Grid>

                        {/* Postal Code */}
                        <Grid item xs={12}>
                          <TextField
                            size={isMobile ? "small" : "medium"}
                            name="postalCode"
                            fullWidth
                            label="Posta Kodu"
                            value={address.postalCode}
                            onChange={(e) =>
                              handleInputChangeAddressUpdate(e, index)
                            }
                            error={!!formErrors.postalCode}
                            helperText={formErrors.postalCode}
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                              "& .MuiInputBase-input": {
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Box
                        sx={{
                          mt: { xs: 1.5, sm: 2 },
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => updateAddress(address)}
                          disabled={loading}
                          sx={{
                            borderRadius: 1,
                            backgroundColor: "#1F1B45",
                            color: "#FFFFFF",
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: { xs: "0.813rem", sm: "0.875rem" },
                            padding: { xs: "8px 16px", sm: "10px 20px" },
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            "&:hover": {
                              backgroundColor: "#2C285A",
                            },
                          }}
                        >
                          {loading ? (
                            <CircularProgress size={20} />
                          ) : (
                            "Güncelle"
                          )}
                        </Button>
                      </Box>
                    </CardContent>
                  </AccordionDetails>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default AddressSettings;
